import React from 'react';
import { SlideFrame } from './SlideFrame';
const nextMoves = ['Close the loop', 'Share the knowledge back', 'Continue the relevant conversation', 'Generate follow-up', 'Turn insight into action'];
export function ActThreeAfterSlide() {
  return <SlideFrame topBand data-id="element-22" data-mp="12bz8jnn44kph">
      <div className="flex items-center gap-[1vw] font-sans text-[clamp(13px,1.05vw,20px)] font-semibold tracking-[0.16em]" data-id="element-23" data-mp="yd03m31dsny1">
        <span className="text-black/35" data-id="element-24" data-mp="1v1y3fznznc22">Act III</span>
        <span className="h-px w-[clamp(28px,3vw,54px)] bg-[#D62B22]" data-id="element-25" data-mp="1q3wjzdmnhaq2" />
        <span className="text-[#D62B22]" data-id="element-26" data-mp="1q4phdnzpynvj">After</span>
      </div>

      <header className="mt-[2.4vh] flex items-end justify-between gap-[5vw]" data-id="element-27" data-mp="1m1jbwikfl0q4">
        <h1 className="max-w-[11ch] font-display text-[clamp(54px,7vw,116px)] font-bold leading-[0.92] tracking-[-0.03em]" data-id="element-28" data-mp="1h3ht7yqx33f6">
          Turn ideas into action
        </h1>
        <p className="mb-[0.8vh] max-w-[29ch] font-display text-[clamp(20px,2vw,34px)] font-medium leading-[1.12] text-black/55" data-id="element-29" data-mp="akt3cssjbwtc">
          The closing act is where the congress starts to pay off.
        </p>
      </header>

      <div className="relative mt-[5vh] pb-[3vh]" data-id="element-30" data-mp="iiyzrk3sbwib">
        <div className="grid grid-cols-5" data-id="element-31" data-mp="iipci4a4k3gb">
          {nextMoves.map((move, index) => <div key={move} className={`relative min-h-[19vh] pr-[1.5vw] ${index > 0 ? 'border-l border-black/15 pl-[1.5vw]' : ''}`} data-id="element-32" data-mp="4iobmotv0w0u" data-mpi={index}>
              <span className="font-sans text-[clamp(10px,0.8vw,15px)] font-semibold tracking-[0.12em] text-[#D62B22]" data-id="element-33" data-mp="3qysfhwqal3yb">
                0{index + 1}
              </span>
              <p className="mt-[1.2vh] max-w-[13ch] font-display text-[clamp(21px,2vw,36px)] font-medium leading-[1.08] text-black/70" data-id="element-34" data-mp="3hycjf8bvoz3h">
                {move}
              </p>
              <span className={`absolute bottom-0 left-0 h-[clamp(5px,0.5vw,9px)] ${index === nextMoves.length - 1 ? 'w-[calc(100%+8vw)] bg-[#D62B22]' : 'w-full bg-black'}`} aria-hidden="true" data-id="element-35" data-mp="3lxv2dyk5303o" />
            </div>)}
        </div>
        <span className="absolute -right-[4.5%] bottom-[0.4vh] font-display text-[clamp(26px,2.8vw,50px)] text-[#D62B22]" aria-hidden="true" data-id="element-36" data-mp="1ijko4maddqe6">→</span>
      </div>

      <div className="mt-auto flex items-end justify-between gap-[5vw] border-t border-black/20 pt-[2.4vh]" data-id="element-37" data-mp="1dq81uit5xvol">
        <p className="max-w-[18ch] font-display text-[clamp(30px,3.4vw,58px)] font-semibold leading-[1.02]" data-id="element-38" data-mp="19ocxt6jul474">
          Don’t let ECCO end <span className="text-[#D62B22]" data-id="element-39" data-mp="21if2hu5x8ott">at ECCO.</span>
        </p>
        <p className="max-w-[34ch] text-right font-sans text-[clamp(13px,1.05vw,19px)] leading-snug text-black/45" data-id="element-40" data-mp="21fki22mwr40e">
          What the audience told us should shape what happens next.
        </p>
      </div>
    </SlideFrame>;
}